import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import relatedCareers from '../../ASUPhotos/icons/me3_RelatedCareers_Image.png';
import BaobabRelatedCareers from '../../BaobabPhotos/BaobabRelatedCareers.png';
import { TopDashboardComponent } from './utility/TopDashboardComponent';
import { CustomCarousel } from './utility/CustomCarousel';
import { getCategoryImages } from '../utility/getCategoryImages';
import { getOnboardingState } from '../../store/selectors';

export class RelatedCareers extends React.Component {
  primaryColor = {
    color: this.props.tenant.primary,
  };

  get careerList() {
    const careerList = getCategoryImages(
      this.props.onboarding.userData.relatedCareers
    );

    return careerList;
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <div id="related-careers" className="related-careers">
            <TopDashboardComponent
              tenant={this.props.tenant}
              headerText={t('Explore Related Careers')}
              headerStyle="related-careers-header"
              appendText="related-careers"
              cornerImage={
                this.props.tenant.name === 'Baobab'
                  ? BaobabRelatedCareers
                  : relatedCareers
              }
              altText={t(
                this.props.tenant.name === 'Baobab'
                  ? 'A person wearing a blazer'
                  : 'A person wearing a yellow shirt'
              )}
              copyDescription={t(
                'Easily explore other careers related to your Top 3 that fit your interests and passions. Find a career that interests you? Add it to your Top 3 to pair it with a degree.'
              )}
              copyWebsiteLink={t('Career Search')}
              websiteLink={`/${this.props.tenant.name.toLowerCase()}/career-search`}
              primaryColor={this.primaryColor}
            />
            {this.props.onboarding.userData.relatedCareers.length > 0 ? (
              <div className="related-careers__custom-carousel-container">
                <CustomCarousel
                  careers={this.careerList}
                  setBrightOutlookModal={this.props.setBrightOutlookModal}
                />
              </div>
            ) : (
              <div className="related-careers__no-carousel-container" />
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  return { onboarding };
};

export default connect(mapStateToProps)(RelatedCareers);
